import React, { useState, useEffect } from "react";
import { adminCommandService } from "../../services/api";
import { Command } from "../../types";
import LoadingSpinner from "../../components/LoadingSpinner";

const AdminCommands: React.FC = () => {
    const [commands, setCommands] = useState<Command[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadCommands();
    }, []);

    const loadCommands = async () => {
        try {
            setIsLoading(true);
            const data = await adminCommandService.getAll();
            setCommands(data || []);
        } catch {
            setError("Erreur lors du chargement des commandes");
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) return <LoadingSpinner />;

    return (
        <div className="max-w-5xl mx-auto p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-6">Toutes les commandes</h1>

            {error && (
                <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">{error}</div>
            )}

            {commands.length === 0 ? (
                <div className="text-center py-12 text-gray-500">Aucune commande</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full bg-white border border-gray-200 rounded-xl shadow-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">#</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Client</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Produits</th>
                                <th className="px-4 py-3 text-right text-sm font-semibold text-gray-600">Total</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {commands.map((command) => (
                                <tr key={command.id} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 text-sm text-gray-500">{command.id}</td>
                                    <td className="px-4 py-3 text-sm font-medium text-gray-800">{command.username}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">
                                        {command.product?.length > 0
                                            ? command.product.map((p) => p.name).join(", ")
                                            : "—"}
                                    </td>
                                    <td className="px-4 py-3 text-sm font-semibold text-gray-800 text-right">
                                        {command.total_price.toFixed(2)} €
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminCommands;
